/**
 * Hard gate mirroring reactdashboard's useAgenticEnabled +
 * useDevFleetCopilotEnabled: Copilot is available on the rebelmouse.com runner,
 * on any rebelmouse.dev host (apex or subdomain — the dev fleet), on a local
 * dev build, plus a localStorage override for QA on other runners.
 */

const ENABLED_HOSTNAME = 'www.rebelmouse.com';
const DEV_FLEET_DOMAIN = 'rebelmouse.dev';
const OVERRIDE_KEY = 'RM_COPILOT_ENABLED';

/** Anchored suffix match: `rebelmouse.dev` and `*.rebelmouse.dev` only. */
export function isDevFleetHost(hostname) {
  if (typeof hostname !== 'string') {
    return false;
  }
  const host = hostname.toLowerCase();
  return host === DEV_FLEET_DOMAIN || host.endsWith(`.${DEV_FLEET_DOMAIN}`);
}

export function isCopilotEnabled() {
  if (typeof window === 'undefined') {
    return false;
  }
  try {
    if (window.localStorage.getItem(OVERRIDE_KEY) === '1') {
      return true;
    }
  } catch {
    /* storage unavailable */
  }
  if (process.env.NODE_ENV === 'development') {
    return true;
  }
  const { hostname } = window.location;
  return hostname === ENABLED_HOSTNAME || isDevFleetHost(hostname);
}
